function Navbar({ menuOpen, setMenuOpen }) {
  return (
    <div className="navbar">
      <div className="navbar-left">
        <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        <h1 className="nav-name">Samantha Nicole Smith</h1>
      </div>

      <a href="/resume.pdf" download className="resume-link">
        PDF CV
      </a>
    </div>
  );
}

export default Navbar;